import $ from 'jquery';
import {onScroll, getScrollTop, getHeight, getWidth} from "../utils/window";

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');
	const $heroMenu = $html.find('.hero-menu-container');
	const $heroMenuItems = $heroMenu.find('a[data-id]');
	const height = getHeight() * 0.25;

	function clearActive() {
		$heroMenuItems.removeClass('-active');
	}

	function setupAnchorSections() {
		let sections = [];
		let ids = [];
		$heroMenuItems.each(function() {
			const $this = $(this);
			const id = $this.attr('data-id')
			sections.push($(id));
			ids.push(id);
		});

		onScroll(()=>{
			if (getWidth() > 1080) {
				checkIfInSection(sections, ids);
			}
		});
	}

	function checkIfInSection(sections, ids) {
		sections.forEach(function($el, index){
			let href = $(`[href="${ids[index]}"]`);

			if (getScrollTop() >= ($el.offset().top - height)) {
				clearActive();
				href.addClass('-active');
			}
		});
	}

	function initialise() {
		setupAnchorSections();
		$heroMenuItems.click(function (e) {
			const $this = $(this);
			setTimeout(()=>{
				clearActive();
				$this.addClass('-active');
			}, 500);
		});
	}

	$(function() {
		initialise();
	});
}

// OLD
// const $header = $('#header');
// const $headerNav = $('#header-nav');
// const headerToggler = $headerNav.data('toggler');
//
// if (headerToggler) {
//
// 	headerToggler.on('toggle', function() {
// 		$html.toggleClass('is-header-open', headerToggler.isOpen);
//
// 		if (headerToggler.isOpen) {
// 			$scroller.animate({ scrollTop: 0 }, { duration: 200 });
// 		}
// 	});
// }



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js